import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getEmployeesTrips } from '../../services/employee';

interface Params {
  employeeIds: string[];
}

function useGetBatchTrips({ employeeIds }: Params) {
  const sortedIds = employeeIds.sort();

  const { data, isLoading, isFetching, isError, isSuccess, error } = useQuery({
    queryKey: ['tripsBatch', sortedIds],
    queryFn: async ({ signal }) => {
      if (!sortedIds.length) return {};
      const response = await getEmployeesTrips(sortedIds, signal);
      return response ?? {};
    },
  });

  // remove any previousData that includes employeeIds that are not in the current employeeIds
  const filteredData = React.useMemo(
    () =>
      Object.keys(data ?? {}).reduce<NonNullable<typeof data>>((acc, key) => {
        if (sortedIds.includes(key)) {
          const value = data?.[key];
          if (value) acc[key] = value;
        }
        return acc;
      }, {}),
    [data, sortedIds],
  );

  return {
    data: filteredData,
    isLoading,
    isFetching,
    isError,
    isSuccess,
    error,
  };
}

export default useGetBatchTrips;
